import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { PartnerEditDialogComponent } from '../partner-edit-dialog/partner-edit-dialog.component';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { IHistoryView } from '../../../shared/history/history.model';
import { HistoryViewComponent } from '../../../shared/history/history-view/history-view.component';
import { PartnerService } from 'src/app/api/services';
import { PartnerWithCustomerCountDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-with-customer-count-dto';
import { PartnerDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-dto';
import { PartnerBaseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { AuditHistoryEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/audit-history-enum';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { PartnerFilter } from 'src/app/components/aftale/models';

@Component({
  selector: 'app-partner-list',
  templateUrl: './partner-list.component.html',
  styleUrls: ['./partner-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PartnerListComponent implements OnInit {
  partnere: PartnerWithCustomerCountDto[] = [];
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(HistoryViewComponent) historyViewComponent: HistoryViewComponent;
  displayedColumns: string[] = ['name', 'partnerNo', 'phone', 'email', 'active', 'customerCount', 'actions'];
  historyView: IHistoryView;

  filter: PartnerFilter = {
    showInactive: false,
  };

  constructor(
    private dialog: MatDialog,
    private service: PartnerService,
    private auth: AuthService,
    private errorHandler: ErrorHandlerService,
    private loader: LoaderService,
    private notifications: NotificationService,
  ) {}

  get canEdit() {
    return this.auth.isAdministrator;
  }

  get partnereSortedByName() {
    return this.partnere.sort((a, b) => (a.name < b.name ? -1 : 1));
  }

  async ngOnInit(): Promise<void> {
    await this.fetchPartnersAsync();
  }

  async edit(row: PartnerWithCustomerCountDto) {
    this.loader.show();
    await this.service
      .getPartner({
        partnerNo: row.partnerNo,
        caller: EGIS_SERVICE_CALLER,
      })
      .toPromise()
      .then((response) => {
        this.openDialog(response);
      })
      .catch((error) => {
        this.errorHandler.HandleError(error);
      })
      .finally(() => {
        this.loader.hide();
      });
  }

  add() {
    this.openDialog({} as PartnerDto);
  }

  openDialog(partner: PartnerDto) {
    let dialogRef = this.dialog.open(PartnerEditDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data: partner,
    });

    dialogRef.afterClosed().subscribe(async (changedPartner) => {
      var partnerBase = changedPartner as PartnerBaseDto;
      const reload = this.historyView && partner && partner.name != partnerBase.name;
      if (partnerBase) {
        let existingPartner = this.partnere.find((p) => p.id == partner.id);

        if (existingPartner) {
          this.notifications.success(`Partner ${partnerBase.name} er opdateret`);
          Object.assign(existingPartner, partnerBase);
        } else {
          this.notifications.success(`Partner ${partnerBase.name} er oprettet`);
          this.partnere.push(changedPartner);
        }

        this.table.renderRows();
        if (partner) {
          if (reload) this.showhistory(partnerBase);
          this.historyViewComponent.render();
        } else this.historyView = null;
      }
    });
  }

  async fetchPartnersAsync() {
    this.loader.show();
    await this.service
      .getAllPartnereWithCustomerCount({
        includeInactive: this.filter.showInactive,
        caller: EGIS_SERVICE_CALLER,
      })
      .toPromise()
      .then((response) => {
        this.partnere = response;
      })
      .catch((error) => {
        this.errorHandler.HandleError(error);
      })
      .finally(() => {
        this.loader.hide();
      });
  }

  showhistory(row: PartnerBaseDto) {
    this.historyView = { entityId: row.id, historyType: AuditHistoryEnum.Partner, title: row.name };
  }

  async filterChange() {
    await this.fetchPartnersAsync();
  }
}
